import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";
import UserSettingsSkin from "./skin";
import UserSettingsViews from "./views/views";
import UserSettings_Navigation from "./navigation/navigation";
import UserMenuSettings from "../../manager/user/menu-settings";
import UserSettings_Debug from "./debug";

// const debug = 'UserSettings'
const debug = false

const fields = {

    'skin': {
        type            : 'class',
    },

    'views': {
        type            : 'class',
    },
    'navigation': {
        type            : ServerSettingsFieldType.CLASS,
        'class'           : UserSettings_Navigation
    },

    'usersManagement': {
        type            : 'class',
    },

    'debug': {
        type            : ServerSettingsFieldType.CLASS,
        'class'           : UserSettings_Debug
    },
}

// This class should replace me.clientData !!!

export default class UserSettings extends ServerSettings {

    public skin         : UserSettingsSkin
    public views        : UserSettingsViews
    public navigation   : UserSettings_Navigation
    public menu         : UserMenuSettings      // Be carefull it's very special and has own save
    public debug        : UserSettings_Debug      // Be carefull it's very special and has own save

    // save may be called multiple times from different places in a short period if time
    // and multiple updateClientData calls may cause unexpected settings updates on session
    // events, therefore debounceSave ensures that only one save in a period is called
    private debounceSave    : any

    constructor(config: any) {
        super(config, fields);

        debug && console.log("SETTINGS CONFIG", config)

        this.skin               = new UserSettingsSkin(_.get(config,'skin'))
        this.views              = new UserSettingsViews(_.get(config,'views'))
        this.navigation         = this.initValue('navigation')
        this.menu               = new UserMenuSettings(config) // config has menu esli chto ...
        this.debug              = new UserSettings_Debug(_.get(config,'debug')) // config has menu esli chto ...

        this.debounceSave = _.debounce(this._onSave, 100)

        debug && console.log("SETTINGS Object", this)
    }


    toJson() {
        // const result = {};
        const result            = gd.user.clientData
        result.skin             = this.skin.toJson()
        result.views            = this.views.toJson()
        result.navigation       = this.navigation.toJson()
        result.menu             = this.menu.toJson()
        result.debug            = this.debug.toJson()

        this.valueToJson(result, 'navigation')

        return result
    }

    private _onSave = (callback?: callback) => {
        debug && console.log(debug, "save user settings", this.toJson())

        if (gd.isSharedView) return

        const request = gd.api.MyAccount.updateClientData({
            clientData: this.toJson()
        });

        request.done(()=>{
            callback && callback();
        })
    }

    save(callback?: callback) {
       this.debounceSave(callback)
    }
}
